import { DialogContent } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/system/Box";
import { useState } from "react";
import { deleteBriefRequested } from "src/slices/brief/thunks";
import { useDispatch } from "src/store";

type PropsType = {
  isOpen: boolean;
  setIsDeleteDialogOpen: (id: string) => void;
  id: string;
};

export default function DeleteDialog({
  isOpen,
  setIsDeleteDialogOpen,
  id,
}: PropsType) {
  const dispatch = useDispatch();
  const [isDeleting, setIsDeleting] = useState(false);

  const onClose = () => {
    if (!isDeleting) {
      setIsDeleteDialogOpen("");
    }
  };

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await dispatch(deleteBriefRequested({ id })).unwrap();
      onClose();
    } catch (error) {
      console.error("Failed to delete brief:", error);
    } finally {
      setIsDeleting(false);
    }
  };
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "8px",
          borderRadius: "8px 8px 0px 0px",
          background:
            "linear-gradient(60.66deg, #FFD875 -3.87%, #DA00C8 26.08%, #6A00FF 56.49%)",
        }}
      />
      <DialogTitle sx={{ mt: 1 }} id="alert-dialog-title">
        Are you sure you want to delete this brief?
      </DialogTitle>
      <DialogContent>
        This item will be deleted immediately. You can't undo this action.
      </DialogContent>
      <DialogActions>
        <Button 
          color="error" 
          onClick={handleDelete}
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={20} /> : undefined}
        >
          {isDeleting ? "Deleting..." : "Yes, Delete"}
        </Button>
        <Button onClick={onClose} autoFocus disabled={isDeleting}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
